import React from 'react'

const GoogleMap = () => {
  return (
    <div>GoogleMap</div>
  )
}

export default GoogleMap